import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

/**
 * Opening a page always builds it fresh, so clicking the current page's menu entry reloads it
 * (together with `onSameUrlNavigation: 'reload'`).
 *
 * The one thing that is kept is the page frame (the route marked `data: { keepFrame: true }`: the
 * layout with the header, side menu and footer), so the side menu is not torn down and does not jump
 * back to the top on every click. Every page inside the frame is rebuilt, as before.
 */
@Injectable()
export class ReloadRouteReuseStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (future.routeConfig !== curr.routeConfig) {
      return false;
    }
    // The router's root has no route config; it is always kept.
    return future.routeConfig === null || future.routeConfig.data?.['keepFrame'] === true;
  }
}
